module.exports = __webpack_public_path__ + "static/media/navigation_moving.71fcb055.png";